import { Stack } from '@mui/material'
import { KeyboardArrowLeft } from '@mui/icons-material'
import { ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useTexts } from '../../../useTexts'
import { Footer } from './Footer'

export function ConfigureColumnsFooter() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    close,
    status,
    invalid,
    data: { selectedOrders },
  } = useController()

  const bulk = selectedOrders.length > 1

  return (
    <Footer>
      <ModalFooterButton onClick={handlers.onPrevButtonClick} testid="modal-tertiary-button">
        <KeyboardArrowLeft />
        {texts.prevStepButton}
      </ModalFooterButton>
      <Stack gap={1} direction="row">
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancelButtonTitle}
        </ModalFooterButton>
        <ModalFooterButton
          disabled={invalid || status !== 'ready'}
          onClick={handlers.exportOrder}
          variant="contained"
          loading={handlers.isLoading}
          testid="modal-primary-button"
        >
          {bulk
            ? texts.exportButtonTitleBulk(selectedOrders.length)
            : texts.exportButtonTitleSingle}
        </ModalFooterButton>
      </Stack>
    </Footer>
  )
}
